"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ellipsis = ellipsis;
function ellipsis(text, limit) {
  if (!text) {
    return '';
  }
  if (text.length > limit) return "".concat(text.substring(0, limit - 1).trim(), "\u2026");
  return text;
}